contently.ui.disable_button = (button) ->
  $(button).removeClass "disabled-spinner"

  if $(button).is("button, input")
    $(button).prop "disabled", true

  $(button).addClass "disabled"

contently.ui.disable_button_with_spinner = (button) ->
  contently.ui.disable_button button
  $(button).addClass "disabled-spinner"

contently.ui.enable_button = (button) ->
  if $(button).is("button, input")
    $(button).prop "disabled", false

  $(button).removeClass "disabled disabled-spinner"



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/buttons.js.coffee